import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-float-label" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "scope",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              id: "scriptLanguage",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.scriptLanguage.$invalid && _ctx.v$.dataset.scriptLanguage.$dirty
                            }],
              style: _ctx.queryDescriptor.style.maxWidth,
              options: _ctx.scriptTypes,
              optionLabel: "VALUE_NM",
              optionValue: "VALUE_CD",
              modelValue: _ctx.v$.dataset.scriptLanguage.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.scriptLanguage.$model = $event)),
              onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.scriptLanguage.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onLanguageChanged($event.value)))
            }, null, 8, ["style", "options", "modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.lovsManagement.language')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.dataset.scriptLanguage,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.lovsManagement.language')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ])
      ]),
      _createVNode(_component_VCodeMirror, {
        class: "p-mt-2",
        ref: "codeMirrorScriptType",
        value: _ctx.dataset.script,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.script = $event)),
        autoHeight: true,
        options: _ctx.scriptOptions,
        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched')))
      }, null, 8, ["value", "options"])
    ]),
    _: 1
  }))
}